export default __webpack_public_path__ + "static/media/95_desktop.47562415.jpg";